import { alpha, styled } from '@mui/material';
import { DatePicker, DatePickerSlotProps } from '@mui/x-date-pickers';
import { RookeryRegularFont } from 'v3/styles/common';

export const DatePickerStyled = styled(DatePicker)(({ theme }) => ({
  width: '100%',
  height: '3rem',
  justifyContent: 'center',
  marginTop: '1.5rem',
  border: 'none',
  borderBottom: `.1rem solid ${theme.palette.secondary.light}`,

  input: {
    font: `400 1rem ${RookeryRegularFont}`,
    color: theme.palette.common.white,

    '&::placeholder': {
      color: alpha(theme.palette.common.white, 0.38),
    },
  },

  fieldset: { border: 'none' },

  '& .MuiInputLabel-root.Mui-focused,& .MuiFormLabel-root': {
    color: `${alpha(theme.palette.common.white, 0.6)} `,
  },

  '& .MuiPickersInputBase-root': {
    color: `${alpha(theme.palette.common.white, 0.6)}`,
  },

  '&:is(:focus-within)': {
    borderBottom: 'double .2rem transparent',
    backgroundImage: `${theme.palette.gradient[500]}, ${theme.palette.gradient[100]}`,
    backgroundRepeat: 'no-repeat',
    backgroundOrigin: 'border-box',
    backgroundSize: '100% 9%',
    backgroundClip: 'padding-box, border-box',
    backgroundPosition: 'bottom',
  },
}));

export const slotProps: DatePickerSlotProps<boolean> = {
  mobilePaper: {
    sx: (theme) => ({
      '& .MuiDialogContent-root': {
        backgroundColor: theme.palette.primary.main,
      },
      '& .MuiTypography-root, & .MuiPickersCalendarHeader-root, & .MuiButtonBase-root': {
        color: theme.palette.common.white,
      },
      '& .MuiPickersYear-yearButton': {
        font: `400 0.875rem ${RookeryRegularFont}`,
        border: '0.063rem solid',
        borderRadius: '1rem',
        '&.Mui-selected': {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.details.dark,
        },
        '&:hover': {
          backgroundColor: theme.palette.details.dark,
        },
      },
      color: theme.palette.common.white,
      borderRadius: '1.25rem',

      [theme.breakpoints.up('lg')]: {
        width: '25rem',
      },
    }),
  },

  day: {
    sx: (theme) => ({
      color: theme.palette.common.white,

      '&.MuiPickersDay-today': {
        borderColor: theme.palette.common.white,
      },

      '&.MuiPickersDay-root': {
        '&.Mui-selected': {
          color: theme.palette.primary.dark,
          backgroundColor: theme.palette.details.main,
        },
        '&:hover': {
          color: theme.palette.primary.dark,
          backgroundColor: theme.palette.details.light,
        },
        '&.Mui-disabled': {
          color: theme.palette.primary.dark,
          backgroundColor: theme.palette.secondary.light,
          opacity: 0.4,
        },
      },
    }),
  },

  textField: {
    sx: (theme) => ({
      '& .MuiInputBase-input': {
        color: theme.palette.common.white,
        WebkitTextFillColor: 'white',
        caretColor: 'white',
      },
      '& .MuiInputLabel-root': {
        color: alpha(theme.palette.common.white, 0.6),
      },
    }),
  },
};
export const Content = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  gap: '1rem',
}));
